import React, { Component } from "react";
import Axios from "axios";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import Paper from "@material-ui/core/Paper";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

import { url } from "../../../../Config/Config";
import { getAdminRefreshToken } from "../../../../Redux/Actions/actions";

class DashboardStudentChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      studentList: [],
      classList: [],
      chartData: [],
    };
  }

  componentDidMount() {
    this.getData();
  }

  getData = async () => {
    try {
      let chartData = [];
      let tempData = [];
      const classResponse = await Axios.get(`${url}/api/schoolclass`, {
        headers: { Authorization: `Bearer ${this.props.adminToken}` },
      });
      if (classResponse.data.classes.length !== 0) {
        for (let i = 0; i <= classResponse.data.classes.length - 1; i++) {
          let studentClass = classResponse.data.classes[i].className;
          tempData.push(studentClass);
        }
        tempData
          .filter((value, index) => tempData.indexOf(value) === index)
          .map((className) =>
            chartData.push({ name: className, Male: 0, Female: 0 })
          );
        this.setState({ classList: classResponse.data.classes, chartData });
      }
      const studentResponse = await Axios.get(`${url}/api/students`, {
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      });

      this.setState({ studentList: studentResponse.data.students });
      this.setChartData();
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.getData();
      }
    }
  };

  setChartData = () => {
    for (let i = 0; i <= this.state.classList.length - 1; i++) {
      let maleFiltered = this.state.studentList.filter((data) => {
        return (
          data.studentClass === this.state.classList[i].className &&
          data.gender === "Male"
        );
      });
      let femaleFiltered = this.state.studentList.filter((data) => {
        return (
          data.studentClass === this.state.classList[i].className &&
          data.gender === "Female"
        );
      });
      this.setData(
        this.state.classList[i].className,
        maleFiltered.length,
        femaleFiltered.length
      );
    }
  };

  setData = (studentClass, maleStudents, femaleStudents) => {
    let newArray;
    newArray = this.state.chartData.map((data) =>
      data.name === studentClass
        ? { ...data, Male: maleStudents, Female: femaleStudents }
        : { ...data, Male: data.Male, Female: data.Female }
    );
    this.setState({
      chartData: newArray,
    });
  };

  render() {
    return (
      <Paper
        style={{
          width: "100%",
          height: "70vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div style={{ fontSize: 20, fontWeight: "bold" }}>
          Student Number Chart
        </div>
        <br />
        {this.state.chartData.length !== 0 ? (
          <ResponsiveContainer width="98%" height="100%">
            <BarChart
              width={500}
              height={300}
              data={this.state.chartData}
              margin={{
                top: 5,
                right: 30,
                left: 20,
                bottom: 5,
              }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="Male" fill="#000099" />
              <Bar dataKey="Female" fill="#ffc0cb" />
            </BarChart>
          </ResponsiveContainer>
        ) : (
          <div>There is no any data present to show in the chart</div>
        )}
      </Paper>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(DashboardStudentChart));
